<template>
  <b-card-actions action-collapse title="Liste des produits">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <!-- <label class="mr-1">Recherche</label> -->
            <b-form-input
              placeholder="Recherche"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllProduct()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-product"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span class="btn-action-table">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="UpdateProduct(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item @click="DeleteProduct(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-else-if="props.column.field == 'image'" >

          <a
            :href="imgFormat(props.row.image)"
            target="_blank"
            v-if="props.row.image"
           
          >             <b-img :src="imgFormat(props.row.image)" class="img-table"
          /></a>
         
        </span>
        <span v-else-if="props.column.field == 'barCode'">
          <barcode
            class="barcode-size"
            :value="props.row.code"
            :options="{ lineColor: '#0275d8', text: 'Scan', height: 20 }"
          ></barcode>
        </span>
        <span v-else-if="props.column.field == 'totalPrice'">
          <p >{{ totalePriceProduct(props.row.priceWithoutTaxes,props.row.valueAddedTax) }}</p>
        </span>
        <span v-else-if="props.column.field == 'totalPriceWithDiscount'">
          <p >{{totalePriceProductDiscount(props.row.discount,props.row.priceWithoutTaxes,props.row.valueAddedTax) }}</p>
        </span>
        
           <span v-else-if="props.column.field == 'description'">
          <p class="p-description">{{ props.row.description }}</p>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Afficher 1 à </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 5,
      dir: false,
      columns: [
          {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Code",
          field: "code",
          filterOptions: {
            enabled: true,
            placeholder: "Code",
          },
        },
        {
          label: "Libélé",
          field: "label",
          filterOptions: {
            enabled: true,
            placeholder: "Libélé",
          },
        },
        {
          label: "Marque",
          field: "brand",
          filterOptions: {
            enabled: true,
            placeholder: "Marque",
          },
        },
        {
          label: "Magasin",
          field: "storeShelf",
          filterOptions: {
            enabled: true,
            placeholder: "Magasin",
          },
        },
        {
          label: "Description",
          field: "description",
          filterOptions: {
            enabled: true,
            placeholder: "Description",
          },
        },

        {
          label: "Quantité",
          field: "quantity",
          filterOptions: {
            enabled: true,
            placeholder: "Quantité",
          },
        },
        {
          label: "Poids",
          field: "weight",
          filterOptions: {
            enabled: true,
            placeholder: "Poids",
          },
        },
        {
          label: "Catégories",
          field: "categories",
          formatFn: this.tableFormat,

          filterOptions: {
            enabled: true,
            placeholder: "Catégories",
          },
        },
        {
          label: "Sous catégories",
          field: "subCategories",
          formatFn: this.tableFormat,

          filterOptions: {
            enabled: true,
            placeholder: "Sous catégories",
          },
        },

        {
          label: "Prix HT",
          field: "priceWithoutTaxes",
          filterOptions: {
            enabled: true,
            placeholder: "Prix HT",
          },
        },
        {
          label: "Tax",
          field: "valueAddedTax",
          filterOptions: {
            enabled: true,
            placeholder: "Tax",
          },
        },
           {
          label: "Remise",
          field: "discount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "P.T sans remise",
          field: "totalPrice",
          filterOptions: {
            enabled: true,
            placeholder: "Prix totale",
          },
        },
     {
          label: "P.T avec remise",
          field: "totalPriceWithDiscount",
          filterOptions: {
            enabled: true,
            placeholder: "Prix totale",
          },
        },
        {
          label: "Marge",
          field: "margin",
          filterOptions: {
            enabled: true,
            placeholder: "Marge",
          },
        },
        {
          label: "Date d'insertion",
          field: "createdAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          filterOptions: {
            enabled: true,
            placeholder: "Agent de saisie",
          },
          formatFn: this.nameFormat,
        },
        {
          label: "Date de modification",
          field: "updatedAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date de modification",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Code a barre",
          field: "barCode",
          sortable: false,
        },
        {
          label: "Image",
          field: "image",
          sortable: false,
          // html: true,
        },
      
      ],
      rows: [],
      searchTerm: "",
    };
  },
  async created() {
    await this.getAllDataProduct();
  },
  methods: {
    async getAllDataProduct() {
      const response = await axios
        .get("https://management-projects.herokuapp.com/api/products")
        .then((response) => {
          console.log(response);
          this.rows = response.data;
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    totalePriceProduct(priceWithoutTaxes,valueAddedTax) {
      if (
       priceWithoutTaxes != 0 &&
        valueAddedTax != 0
      ) {
        return (
         priceWithoutTaxes *
          (1 + valueAddedTax / 100))
      }
    },
    totalePriceProductDiscount(discount,priceWithoutTaxes,valueAddedTax) {
       var totalPrice = this.totalePriceProduct(priceWithoutTaxes,valueAddedTax)
      if (discount != 0 && totalPrice != 0) {
        return( totalPrice - ( totalPrice * ( discount / 100) ))
      }
    },
    DeleteProduct(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer ce produit ?",
        text: "Vous ne pourrez pas annuler cela!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var payload = {
            deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
          };
          axios
            .delete(
              `https://management-projects.herokuapp.com/api/products?ids=${id}&deletedBy=${
                JSON.parse(localStorage.getItem("userData"))._id
              }`
            )
            .then((response) => {
              this.getAllDataProduct();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Produit bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de la suppression`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
      // delete many  product
      deleteAllProduct() {
      var deleteIds = [];
      this.$refs["table-product"].selectedRows.forEach((element) => {
        deleteIds.push(element._id);
      });
      console.log(deleteIds, this.$refs["table-product"].selectedRows);
      axios
        .delete(
          `https://management-projects.herokuapp.com/api/products?ids=${deleteIds.join(
            ","
          )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
        )
        .then((response) => {
          this.getAllDataProduct();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Produit bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la suppression`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    // update product
    UpdateProduct(id) {
      var routerLink = "/stock/edit-stock?id=" + id;
      this.$router.replace(routerLink);
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    imgFormat(value) {
      if (value) {
        return (
          "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
          value
        );
      }
    },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    // table Format
    tableFormat: function (value) {
      const table = value.map((element) => {
        return element.label;
      });
      return table.toString();
    },
    // name agent de saisie
    nameFormat: function (value) {
        if (value != null) {
        return value.firstName + " " + value.lastName;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}

.p-description {
  height: 60px;
  width: 250px;
  overflow: auto;
}
.barcode-size svg {
  height: 80px;
}
</style>
